/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  DeleteReminderMutationResponse,
  DeleteReminderPathParams,
  DeleteReminder400,
  DeleteReminder404,
  DeleteReminder500,
} from '../types/DeleteReminder'

function getDeleteReminderUrl({ id }: { id: DeleteReminderPathParams['id'] }) {
  const res = {
    method: 'DELETE',
    url: `/api/v1/reminders/reminders/${id}/` as const,
  }
  return res
}

/**
 * @description Delete a reminder.
 * Delegates to DeleteReminderUsecase for business logic.
 * @summary Delete a reminder
 * {@link /api/v1/reminders/reminders/:id/}
 */
export async function deleteReminder(
  { id }: { id: DeleteReminderPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    DeleteReminderMutationResponse,
    ResponseErrorConfig<
      DeleteReminder400 | DeleteReminder404 | DeleteReminder500
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteReminderUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
